import { useLocation, useNavigate } from "@tanstack/react-router"
import { Tabs, TabsList, TabsTrigger } from "design-system/molecules/Tabs"
import { MessageCircleCode, MessageSquareLock, Settings, TriangleAlert } from "lucide-react"
import { useTranslation } from "react-i18next"

export const WhatsappTabs = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const tabs = [
    {
      label: t("settings.integrations.whatsapp.tabs.configuration"),
      to: "/settings/channels/whatsapp",
      icon: Settings,
    },
    {
      label: t("campaigns.templates.whatsapp.title"),
      to: "/settings/channels/whatsapp/templates",
      icon: MessageSquareLock,
    },
    {
      label: t("campaigns.templates.openingMessages.title"),
      to: "/settings/channels/whatsapp/openings",
      icon: MessageCircleCode,
    },
    {
      label: t("settings.integrations.whatsapp.tabs.alerts"),
      to: "/settings/channels/whatsapp/alerts",
      icon: TriangleAlert,
    },
  ]

  const currentLocation = tabs.findLast((e) => location.pathname.startsWith(e.to)) ?? tabs[0]

  const navigateTo = (tab: (typeof tabs)[number]) => {
    navigate({ to: tab.to })
  }

  return (
    <Tabs defaultValue={currentLocation?.label}>
      <TabsList>
        {tabs.map((tab) => (
          <TabsTrigger value={tab.label} key={tab.to} onClick={() => navigateTo(tab)}>
            <div className="flex gap-2 items-center">
              <tab.icon />
              <span>{tab.label}</span>
            </div>
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
